import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

const AutopayUnavailableTooltip = ({ children, message, width, inline }) => {
  const triggerRef = useRef(null);
  const [coords, setCoords] = useState(null);

  const show = () => {
    const node = triggerRef.current;
    if (!node) return;

    const rect = node.getBoundingClientRect();
    setCoords({
      left: rect.left + (rect.width / 2),
      top: rect.top - 10,
      width: width || rect.width,
    });
  };

  const hide = () => setCoords(null);

  return (
    <span
      ref={triggerRef}
      className={`autopay-unavailable-trigger${inline ? ' is-inline' : ''}`}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}
      {coords && createPortal(
        <div
          className="autopay-unavailable-bubble"
          role="tooltip"
          style={{
            left: coords.left,
            top: coords.top,
            width: coords.width,
          }}
        >
          {message}
        </div>,
        document.body
      )}
    </span>
  );
};

AutopayUnavailableTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string.isRequired,
  width: PropTypes.number,
  inline: PropTypes.bool,
};

AutopayUnavailableTooltip.defaultProps = {
  width: null,
  inline: false,
};

export default AutopayUnavailableTooltip;
